/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ApartmentJuicyIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="apartment-juicy"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <rect x={9} y={19} width={1.5} height={2.5} stroke={color} fill={color} data-stroke-tone="primary" data-fill-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M15 21.5L15 8.53C15.829 8.524 16.658 8.517 17.487 8.513C18.15 8.51 18.783 8.842 19.156 9.391C19.253 9.534 19.332 9.69 19.389 9.854C19.463 10.065 19.5 10.289 19.5 10.513C19.502 14.176 19.5 17.838 19.5 21.5L15 21.5Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M4.5 21.5L4.5 4.5C4.5 3.395 5.395 2.5 6.5 2.5L13 2.5C14.105 2.5 15 3.395 15 4.5L15 21.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M15 8.53L17.487 8.513C18.596 8.506 19.5 9.404 19.5 10.513L19.5 21.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M8 6L8 9" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M11.5 6L11.5 9" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M8 12.5L8 15.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M11.5 12.5L11.5 15.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M2.5 21.5L21.5 21.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
    </svg>
  )
}
